import MenuBookIcon from '@mui/icons-material/MenuBook';
import ImageIcon from '@mui/icons-material/Image';
import PrintIcon from '@mui/icons-material/Print';
import LinearProgress from '@mui/material/LinearProgress';
import {
	GRADIENT_STEPPER_ACTIVE,
	COLOR_STEPPER_INACTIVE_TEXT,
	COLOR_STEPPER_INACTIVE_BG,
} from '../../../styles/tokens';

function Stepper(props) {
	const { activeStep } = props;
	const activeColor = '#FFFFFF';
	const inactiveColor = COLOR_STEPPER_INACTIVE_TEXT;

	return (
		<>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<CircleIcon active={activeStep >= 0}>
					<ImageIcon
						style={{
							color:
								activeStep >= 0 ? activeColor : inactiveColor,
							fontSize: 30,
						}}
					/>
				</CircleIcon>

				<LinearProgress
					style={{ flex: 1 }}
					variant="determinate"
					value={activeStep > 0 ? 100 : 0}
				/>

				<CircleIcon active={activeStep >= 1}>
					<MenuBookIcon
						style={{
							color:
								activeStep >= 1 ? activeColor : inactiveColor,
							fontSize: 30,
						}}
					/>
				</CircleIcon>

				<LinearProgress
					style={{ flex: 1 }}
					variant="determinate"
					value={activeStep > 1 ? 100 : 0}
				/>

				<CircleIcon active={activeStep >= 2}>
					<PrintIcon
						style={{
							color:
								activeStep >= 2 ? activeColor : inactiveColor,
							fontSize: 30,
						}}
					/>
				</CircleIcon>
			</div>
		</>
	);
}

function CircleIcon(props) {
	const { active } = props;
	const styling = {
		height: '60px',
		width: '60px',
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	};

	if (active) {
		styling.backgroundImage = GRADIENT_STEPPER_ACTIVE;
	} else {
		styling.backgroundColor = COLOR_STEPPER_INACTIVE_BG;
	}

	return <div style={styling}>{props.children}</div>;
}

export default Stepper;
